<template>
  <div
    id="variable-table">
    <table-component
      ref="variableTable"
      :data="fetchData"
      :showFilter="true"
      sort-by="id"
      sort-order="asc"
      :show-caption="false"
      class="datatable"
      filter-placeholder=""
      filterNoResults="">
      <table-column
        show="clientReference"
        :label="$t('variables.reference')"
        header-class="table-component__minimum__width__column"
        cell-class="table-component__text-left">
      </table-column>
      <table-column
        show="name"
        :label="$t('variables.name')"
        header-class="text-left"
        cell-class="table-component__text-left">
      </table-column>
      <table-column
        :label="$t('variables.unit')"
        show="unit"
        header-class="text-left"
        cell-class="table-component__text-left">
      </table-column>
      <table-column
        :label="$t('variables.tags')"
        :filterable="false"
        :sortable="false">
        <template
          slot-scope="row">
          <tags
            :value="row.tags" />
        </template>
      </table-column>
      <table-column
        :label="$t('variableManagement.origin')"
        show="aggregate"
        header-class="text-left"
        cell-class="table-component__text-left">
        <template
          slot-scope="row">
          {{ getVariableOrigin(row) }}
        </template>
      </table-column>
      <table-column
        :label="$t('variableManagement.type')"
        show="categoryId"
        header-class="text-left"
        cell-class="table-component__text-left">
        <template
          slot-scope="row">
          <div
            v-tooltip.left.top-start="{content: categoricalTooltip(row)}">
            {{ getVariableType(row) }}
          </div>
        </template>
      </table-column>
      <table-column
        label=""
        header-class="table-component__minimum__width__column"
        :sortable="false"
        :filterable="false">
        <template slot-scope="row">
          <font-awesome-icon
            v-on:click="onEditVariable(row)"
            :icon="icon.edit"
            class="table-iconset-icon edit"/>
        </template>
      </table-column>
    </table-component>
  </div>
</template>

<script>
import TableColumn from '@/components/shared/table/components/TableColumn';
import TableComponent from '@/components/shared/table/components/TableComponent';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import { faPencilAlt } from '@fortawesome/pro-regular-svg-icons';
import Tags from '@/components/variable/Tags';
import {mapGetters} from 'vuex';

export default {
  name: 'VariableTable',
  components: {
    Tags,
    TableColumn,
    TableComponent,
    FontAwesomeIcon
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      icon: {
        edit: faPencilAlt
      },
      filter: '',
      filterTimer: null
    };
  },
  watch: {
    data: {
      handler: function () {
        this.$refs.variableTable.refresh();
      }
    }
  },
  computed: {
    ...mapGetters([
      'getCategories'
    ])
  },
  methods: {
    onEditVariable (row) {
      this.$emit('onEdit', row);
    },
    getVariableOrigin (row) {
      return row.aggregate ? this.$t('variableManagement.aggregate') : this.$t('variableManagement.raw');
    },
    getVariableType (row) {
      return row.categorized ? this.$t('variableManagement.categorical') : this.$t('variableManagement.quantitative');
    },
    categoricalTooltip (row) {
      if (!row.categorized) {
        return '';
      }
      let tooltipText = '';
      const rowCategory = this.getCategories.find(category => category.id === row.categoryId);
      if (rowCategory !== undefined) {
        rowCategory.ranges.forEach(categoryRange => {
          tooltipText += categoryRange.value + ': ' + categoryRange.name + '</br>';
        });
      }
      return tooltipText;
    },
    fetchData ({context, page, filter, sort}) {
      if (this.filter !== filter) {
        this.filter = filter;
        if (this.filterTimer !== null) clearTimeout(this.filterTimer);
        this.filterTimer = setTimeout(() => {
          this.$emit('onRetrieveVariables', {page: page, filter: filter, sort: sort});
          this.filterTimer = null;
        }, 500);
      } else {
        this.$emit('onRetrieveVariables', {page: page, filter: filter, sort: sort});
      }
      if (typeof this.data === 'object' && this.data !== null && this.data.data && this.data.pagination) {
        return this.data;
      }
      return {
        data: [],
        pagination: {}
      };
    }
  }
};
</script>

<style lang="scss">
  @import "../../stylesheets/variables.scss";

  .tags {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .edit {
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// src/components/variable/VariableTable.vue